import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { useEffect, useRef } from "react";
import className from "classnames/bind";
import { AnimatePresence, motion } from "motion/react";
import { useTicketing } from "../TicketingProvider";
import TicketRow from "./Components/TicketRow";
import TicketingAccordion from "./Components/Accordion";
import { useViewSize } from "@/providers/ViewSizeContext";
import { useClientMount } from "@/providers/ClientMountProvider";

import styles from "./TicketingForm.module.scss";
const cx = className.bind(styles);

export default function StepTwo() {
  const {
    selectedSession,
    timesLoading,
    hasSessions,
    data: {
      step3Label,
      step3Subtext,
      formVariant,
      step3Tickets,
    }
  } = useTicketing();
  const { mounted } = useClientMount();
  const { viewHeight, isReady } = useViewSize();
  const isGeneral = formVariant?.[0] === "general";
  const rootEl = useRef<HTMLDivElement>(null);
  const showStep = Boolean(selectedSession && hasSessions && !timesLoading);
  const scrollToStep = (anim: { opacity: 0 | 1 }) => {
    if (!mounted || !isReady) return;
    if (!selectedSession || !rootEl.current || anim.opacity === 0) return;
    gsap.to(window, { duration: 0.5, scrollTo: { y: rootEl.current, offsetY: (viewHeight - rootEl.current.offsetHeight) / 2 } });
  };
  useEffect(() => {
    if (!mounted || !isReady) return;

    gsap.registerPlugin(ScrollToPlugin);
  }, [mounted, isReady]);
  return (
    <div className={cx(["step", "step-three"])} ref={rootEl}>
      <div className={cx("step__copy")}>
        <p className={cx(["step-label", "text-l"])}>{step3Label}</p>
        <p className={cx(["step-desc", "text-m"])}>{step3Subtext}</p>
      </div>
      <AnimatePresence>
        {
          showStep && (
            <motion.div
              className={cx("step-three__content-wrapper")}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onAnimationStart={scrollToStep}
            >
              <div className={cx("step-three__ticket-options")}>
                {step3Tickets?.nodes.map((ticket, index) => (
                  <TicketRow key={index} ticket={ticket} />
                ))}
              </div>
              { isGeneral && ( <TicketingAccordion /> )}
            </motion.div>
          )
        }
      </AnimatePresence>
    </div>
  );
}
